import Utils from "./utilities"

export default class DomUtils {

    public static selectAllByQuery(el: Element, selector: string): Array<Element> {
        return Utils.asArray(el.querySelectorAll(selector))
    }

    public static swapElementsClass(addElement: HTMLElement, removeElement: HTMLElement, clazz: string): void {
        addElement.classList.add(clazz)
        removeElement.classList.remove(clazz)
    }

    public static unCloak(): void {
        Utils.asArray(document.querySelectorAll('.cloakable'))
            .forEach(cloakableItem => cloakableItem.classList.remove('cloak'))
    }
}